const animations = {
  easing: { tension: 100, friction: 20, velocity: 3 },
  noticeEasing: { tension: 250, friction: 15, velocity: 5 },
  pagerFrom: {
    BACKWARD: {
      opacity: 0,
      position: 'absolute',
      transform: 'translateY(-50px)',
    },
    FORWARD: {
      opacity: 0,
      position: 'absolute',
      transform: 'translateY(50px)',
    },
  },
  pagerEnter: {
    BACKWARD: {
      opacity: 1,
      position: 'relative',
      transform: 'translateY(0px)',
    },
    FORWARD: {
      opacity: 1,
      position: 'relative',
      transform: 'translateY(0px)',
    },
  },
  pagerLeave: {
    BACKWARD: {
      opacity: 0,
      transform: 'translateY(50px)',
      pointerEvents: 'none',
      position: 'absolute',
    },
    FORWARD: {
      opacity: 0,
      transform: 'translateY(-50px)',
      pointerEvents: 'none',
      position: 'absolute',
    },
  },
  noticeFrom: {
    left: 0,
    opacity: 0,
    position: 'absolute',
    top: 0,
    zIndex: 10,
  },
  noticeEnter: {
    left: 0,
    opacity: 1,
    position: 'absolute',
    top: 0,
    zIndex: 10,
  },
  noticeLeave: {
    left: 0,
    opacity: 0,
    pointerEvents: 'none',
    position: 'absolute',
    top: 0,
    zIndex: 10,
  },
};

export const animationDirection = {
  BACKWARD: 'BACKWARD',
  FORWARD: 'FORWARD',
};

export default animations;



// WEBPACK FOOTER //
// ./src/constants/animations.js